import React from "react";
import { Reveal, CreditChip } from "@/components/site/primitives";
import { ABOUT_HERO } from "@/content/about";

export const AboutHero = () => (
  <section id="top" className="relative flex min-h-[72vh] items-end overflow-hidden bg-[var(--wf-soil)]">
    <img
      src={ABOUT_HERO.image}
      alt={ABOUT_HERO.imageAlt}
      loading="eager"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/25" />
    <div aria-hidden="true" className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/40 to-transparent" />

    <div className="wf-container relative z-10 pb-16 pt-36 sm:pb-24">
      <Reveal className="max-w-3xl">
        {ABOUT_HERO.eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-[rgba(255,253,248,0.85)]">
            <span aria-hidden="true" className="h-px w-8 bg-[rgba(255,253,248,0.6)]" />
            {ABOUT_HERO.eyebrow}
          </span>
        )}
        <h1
          data-testid="about-hero-headline"
          className="mt-5 font-serif text-4xl font-semibold leading-[1.05] tracking-[-0.01em] text-white [text-shadow:0_2px_24px_rgba(0,0,0,0.45)] sm:text-6xl lg:text-7xl"
        >
          {ABOUT_HERO.title}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-7 text-[rgba(255,253,248,0.92)] sm:text-lg">
          {ABOUT_HERO.lede}
        </p>
      </Reveal>
    </div>

    <CreditChip src={ABOUT_HERO.image} className="absolute bottom-3 right-3 z-10 rounded-full bg-black/45 px-3 py-1 text-[11px] font-medium text-white/90 backdrop-blur-sm hover:bg-black/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" />
  </section>
);
